import { Component, OnInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { SignatureRequestSummarySectionComponent } from '../../components/signature-request-summary-section/signature-request-summary-section.component';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { SignatureRequestDetailViewModel } from '../../models/signature-request.viewmodel';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';
import { SignatureRequestsService } from '../../signature-requests.service';
import { SignatureRequestParticipantListSectionComponent } from '../../components/signature-request-participant-list-section/signature-request-participant-list-section.component';
import { SignatureRequestDocumentListComponent } from '../../components/signature-request-document-list/signature-request-document-list.component';
import { SignatureRequestDocumentListCardsComponent } from '../../components/signature-request-document-list-cards/signature-request-document-list-cards.component';

@Component({
  selector: 'app-signature-request-detail-page',
  standalone: true,
  imports: [MatCardModule, 
    CommonModule, SignatureRequestSummarySectionComponent, SignatureRequestParticipantListSectionComponent, SignatureRequestDocumentListComponent, SignatureRequestDocumentListCardsComponent],
  templateUrl: './signature-request-detail-page.component.html',
  styleUrls: ['./signature-request-detail-page.component.scss']
})
export class SignatureRequestDetailPageComponent implements OnInit {

  public isOnMobile: boolean;

  public signatureRequestDetail$: Observable<SignatureRequestDetailViewModel>;
  signatureRequestId: bigint;
  constructor(
    private route: ActivatedRoute, 
    private signatureRequestsService: SignatureRequestsService,
    private breakpointObserver: BreakpointObserver
  ){
  }
  ngOnInit(): void {
    this.breakpointObserver.observe([Breakpoints.Handset]).subscribe(result => {
      this.isOnMobile = result.matches;
    });

    this.route.paramMap.subscribe(params => {
      this.signatureRequestId = BigInt(params.get('id')!);
      this.fetchSignatureRequestDetail(this.signatureRequestId);
    });
  }

  private fetchSignatureRequestDetail(id: bigint): void {
    this.signatureRequestDetail$ = this.signatureRequestsService.getSignatureRequestById(id);
  }


}
